<template>

  <div class="add-mentee-form">   
    <div class="add-form-wrapper">
      <div class="row">
        <div class="col">
          <h3 class="add-form-heading" v-show="userType == 'manager'">Edit Manager</h3>
          <h3 class="add-form-heading" v-show="userType == 'mentor'">Edit Mentor</h3>          
        </div>
        <div class="col text-right" v-if="padminflag == true">
          &nbsp;
        </div>
        <div class="col text-right" v-else>
          &nbsp;
        </div>
      </div>
    </div>
  
    <div class="content-main-wrapper center">

      <div class="row" v-show="successMessage != ''">
        <div class="col-12 p-0">
          <div class="alert alert-success" role="alert">
            {{ successMessage }}
          </div>  
        </div>
      </div>

      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-12 p-0">
            <input
              type="first_name"
              name="first_name"
              id="first_name"
              class="col-12 col-sm-12 input-height-35 form-control"
              ref="first_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }"
              v-model="first_name"
              data-vv-as="First name"
              placeholder="First Name"
              maxlength="180">
            <div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">The First Name is required</div>
            <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">The First Name should only contain - and _</div>
          </div>
        
            <div class="col-12 p-0" style="margin-top: 10px;">     
            <input
              type="last_name"
              name="last_name"
              id="last_name"
              class="col-12 col-sm-12 input-height-35 form-control"
              ref="last_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }"
              v-model="last_name"
              data-vv-as="Last name"
              placeholder="Last Name"
              maxlength="180">
            <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">The Last Name is required</div>
            <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">The Last Name should only contain - and _</div>
          </div>
        
          <div class="col-12 p-0" style="margin-top: 10px;">
          <label
              for="email"
              class="font-weight-bold d-block mb-0">Email Address:</label>
                    {{ email_addr }}
          </div>

          <div class="col-12 p-0" style="margin-top: 10px;">         
            <input
                type="phone_number"
                name="phone_number"
                id="phone_number"
                class="col-12 col-sm-12 input-height-35 form-control"
                ref="phone_number"
                @keyup="adminPhoneValid($event)"
                @blur="adminPhoneValid($event)"
                v-validate="{ rules: { regex: adminPhoneRegex() } }"
                v-model="phone_number"
                data-vv-as="Phone number"
                placeholder="Phone Number"
                maxlength="14">
            <div v-if="verrors.has('phone_number')" class="validate-warning-msg">The Phone Number is invalid</div>
          </div>

          <div class="col-12 p-0 mt-3" v-if="userType == 'mentor'">
            <label
                for="mentor"
                class="col-12 bold"> Assign Mentees</label>
                
                <div class="ml-3" v-if="menteesApprentices.length == 0">No mentees added, yet!</div>

                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in menteesApprentices">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_mentee_' + option.id" v-model="assign_mentees">
                    <label class="custom-control-label" :for="form_type + '_mentee_' + option.id">{{ option.first_name + ' ' + option.last_name }}</label>
                  </div>
                </div>
          </div>


          <div class="col-12 p-0" v-if="userType == 'mentor'">

              <div class="col-12 p-0 mt-3" v-if="taskList.length > 0">
                <label
                    for="roles"
                    class="col-12 bold">Assign Tasks </label>

                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in taskList">

                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_assessment_chkbox_' + option.id" name="Tasks" v-model="taskListSelected"  v-validate="'required'">
                    <label class="custom-control-label" :for="form_type + '_assessment_chkbox_' + option.id">{{ option.name }}</label>
                  </div>

                </div>


                <div v-show="verrors.has('Tasks')" class="validate-warning-msg">You have to assign Tasks</div>
              </div>


           <div class="col-12 p-0"  v-if="editPathwayList.length > 0" style="margin-top: 10px;">
                <label
                    for="roles"
                    class="col-12 bold">Assign Pathway: </label>
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(pathway, key, index) in editPathwayList">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="pathway_assigned"
                        :value="pathway.id"                       
                        type="radio" 
                        v-model="editpathwaySelected"
                        @change="getPathwaySteps"
                        v-validate="'required'"
                        class="custom-control-input"
                        :id="'edit_mentee_pathway_' + pathway.id"
                        >
                      <label class="custom-control-label" :for="'edit_mentee_pathway_' + pathway.id">{{ pathway.pathwayName }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="verrors.has('pathway_assigned')" class="margin-bottom-5 validate-warning-msg">Pathway is required</div>
           </div>


           <div class="col-12 p-0"  v-if="editPathwayList.length > 0 && editpathwaySelected > 0" style="margin-top: 10px;">
               <div class="row">
                <div class="col-8 d-inline"> 
                  <label
                      for="roles"
                      class="col-12 bold">Begin at step: </label>
                </div>     
                <div class="col-4">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-checkbox">
                      <input 
                        name="future steps"
                        value="1"                                           
                        type="checkbox" 
                        v-model="editShowFutureSteps"                      
                        class="custom-control-input"
                        :id="'edit_mentee_future_steps'" 
                        >
                      <label class="custom-control-label" :for="'edit_mentee_future_steps'">Show future steps</label>
                    </div>
                  </div>
                </div>
               </div> 
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(step, key, index) in pathwaySteps">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="Begin at step"
                        :value="step.id"                       
                        type="radio" 
                        v-model="editStepSelected"                      
                        class="custom-control-input"
                        :id="'edit_mentee_step_' + step.id"
                        >
                      <label class="custom-control-label" :for="'edit_mentee_step_' + step.id">{{ step.stepTitle }}</label>
                    </div>
                  </div>
                </div>
           </div>


            <div class="col-12 p-0" style="margin-top: 7px;" v-if="editpathwaySelected > 0">
              <label
                  for="mentor"
                  class="col-12 bold"> Assign Mentors: <span class="required">*</span></label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper"  v-for="(option, key, index) in groups">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        <input 
                        name="mentor_assigned"
                        :value="option.id" 
                        :id="'add_mentee_mentor_' + option.id" 
                        type="checkbox" 
                        v-model="mentor_assigned"
                        v-validate="'required'"
                        class="custom-control-input"
                        > 
                        <label class="custom-control-label" :for="'add_mentee_mentor_' + option.id">{{ option.groupName }}</label> 
                      </div>
                    </div>
                  </div>
                  <div v-if="verrors.has('mentor_assigned')" class="margin-bottom-5 validate-warning-msg">Mentor is required</div>

            </div>



          </div>

          <div class="col-12 p-0" v-if="userType == 'manager'">

          <div class="col-12 p-0 mt-3" v-if="assessments.length > 0">
            <label
                for="roles"
                class="col-12 bold">Assign Assessments </label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in assessments">
              <!-- <div class="chkboxwrapper">
                <input 
                  name="Assessment assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="assessmentSelected"
                  >
                <label :for="option.name">{{ option.name }}</label>
              </div> -->

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_assessment_chkbox_' + option.id" v-model="assessmentSelected">
                <label class="custom-control-label" :for="form_type + '_assessment_chkbox_' + option.id">{{ option.name }}</label>
              </div>

            </div>
          </div>

          <div class="col-12 p-0 mt-3" v-if="courses.length > 0"  style="margin-top: 10px;">
            <label
                for="courses"
                class="col-12 bold">Assign Courses</label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in courses">
              <!-- <div class="chkboxwrapper">
                <input 
                  name="Course assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="courseSelected"
                  >
                <label :for="option.name">{{ option.name }}</label>
              </div> -->

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_course_chkbox_' + option.id" v-model="courseSelected">
                <label class="custom-control-label" :for="form_type + '_course_chkbox_' + option.id">{{ option.name }}</label>
              </div>

            </div>
          </div>


          </div>
          




        </div>

        <div class="submit margin-bottom-15 mt-3" style="text-align: center;">
          <button :disabled="disable_edit_btn" type="submit" class="btn btn-info ma-blue-btn" v-show="form_type == 'edit_user'">Save</button>
        </div>
      </form>
    </div>
  </div>  
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['form_type'],
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
      password: '',
      pw_confirm: '',
      accountId: '',
      formType: (this.$route.name == 'updatemanager') ? 'Manager' : 'Mentor',
      menteeAssessment: [],
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
      // buttonAction: 'save',
      successMessage: '',
      menteeCount: '',
      menteesApprentices: [],
      assign_mentees: [],
      userType: '',
      userStatus: '',
      userId: '',
      disable_edit_btn: false,
      padminflag: false,
      editPathwayList: [],
      pathwaySteps: [],
      editpathwaySelected: '',
      stepSelected: '',
      editStepSelected: '',
      editShowFutureSteps: 0,
      defaultstep: '',
      pathwaySteps: [],
      stepSelected: '',
      taskList: [],
      taskListSelected: [],
      existingPathway: '',
      mentor_assigned: [],
      groups: [],
    };
  },
  computed: {
    getFormTitle() {
      return (this.$route.name == 'updatemanager') ? 'Manager' : 'Mentor';
    }
  },
  methods: {
    getPathwaySteps() {
      this.pathwaySteps = [];
      this.defaultstep = '';
      this.stepSelected = '';
      axios('/get-pathway-steps-name',
          {
            method: 'GET',
            params: {
              pathway_id: this.editpathwaySelected,
            }
          },
        )
        .then(response => {
              this.defaultstep = response.data[0].id;            
              this.pathwaySteps = response.data;
         })
        .catch(error => {

        });
    },
    getPathwayLists() {
      axios('/get-pathway-add-mentee',
            {
              method: 'GET',
              params: {
                account_id: this.$store.state.user_accountid,
              }
            },
          )
          .then(response => {
              var list =  { id: 0, pathwayName: 'No Pathway' };
              this.editPathwayList.push(list);
              for(var i=0; i < response.data.length; i++) {
                var list = {id: response.data[i].id, pathwayName: response.data[i].pathwayName};
                this.editPathwayList.push(list);
              }
              
           })
          .catch(error => {

          });
    },       
    inactivateUserConfirm(id, first_name, last_name) {
        const item = {};
        item.id = id;
        item.first_name = first_name;
        item.last_name = last_name;
        this.name = first_name + ' ' + last_name;           
        this.$parent.$parent.inactivateUser(item);
    },
    inactivatePrimaryUserConfirm() {
      const item = {};
      item.id = this.userId;
      item.first_name = this.first_name;
      item.last_name = this.last_name;
      item.email = this.email_addr;
      this.$parent.$parent.openUpdatePrimaryManagerModal(item);
    },
  nameRegex: function() {
    return /^[a-zA-Z-_ ']*$/;
  },
  adminPhoneRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  },
  adminPhoneValid: function(event) {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
  doFormReset() {
    this.first_name = '';
    this.last_name = '';
    this.phone_number = '';
    this.email_addr = '';
    this.assessmentSelected = [];
    this.courseSelected = [];
    this.assign_mentees = [];
    this.assign_mentees = [];
    this.editpathwaySelected = 0;
    this.editShowFutureSteps = '';
    this.editStepSelected = '';
    this.defaultstep = '';
    this.existingPathway = 0;
    this.taskListSelected = [];
    this.taskList = [];
    this.editPathwayList = [];
    this.pathwaySteps = [];
    this.mentor_assigned = [];
    this.groups = [];

    this.$validator.reset();
  },
  onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.createMentor();
      })
      .catch(() => {

      });
  },
  createMentor() {

    if (this.userType == 'mentor') {
      this.disable_edit_btn = true;
      this.assessmentSelected = [];
      this.courseSelected = [];
      for(var k=0; k < this.taskListSelected.length; k++) {
        var idd = this.taskListSelected[k];
        var myArray = idd.split("-");
        if(myArray[1] == 'Assessment') {
          this.assessmentSelected.push(myArray[0]);
        }
        if(myArray[1] == 'Course') {
          this.courseSelected.push(myArray[0]);
        }
      }
      if(this.editpathwaySelected == 0) {
        this.mentor_assigned = [];
      }
      axios('/desktop/v2/mentor-update',
      {
          method: 'POST',
          data: {
            "first_name": this.first_name,
            "last_name": this.last_name,
            "phone_number": this.phone_number,
            "mentor_id" : this.userId,
            "assign_mentees": this.assign_mentees,
            "pathway_assigned": this.editpathwaySelected,
            "show_future_steps": this.editShowFutureSteps,
            "begin_step": this.editStepSelected,
            "account_id": this.$store.state.user_accountid,
            "existing_pathway": this.existingPathway,
            "assessments_assigned": this.assessmentSelected,
            "courses_assigned": this.courseSelected,
            "mentor_assigned": this.mentor_assigned,
          }
      },
      )
      .then((response)=> {     
        this.disable_edit_mentee = false;              
          this.successMessage = 'Mentor Edited Successfully!';
          this.$refs.first_name.focus();

          this.doFormReset();
          setTimeout(() => {
            this.successMessage = '';
            this.$emit('closeMentorModal');
            window.location.reload(); 
          }, 2000);

      })
      .catch(() => {
        this.disable_edit_mentee = false;
      });

    }
    else {

      this.disable_edit_btn = true;
      //make axios call to the API
      axios('/mobile/user-profile/' + this.userId,
        {
            method: 'PATCH',
            data: {
                "first_name": this.first_name,
                "last_name": this.last_name,
                "phone_number": this.phone_number,
                "assessments_assigned": this.assessmentSelected,
                "courses_assigned": this.courseSelected,
                "accountId": this.accountId,
                "assign_mentees": this.assign_mentees,
            }
        },
    )
    .then(response => {
        // this.flash({ message: response.data.successMsg, variant: 'success' });
        // this.navigate('/company-admin-dashboard');

        this.disable_edit_btn = false;
        this.successMessage = 'Manager Edited Successfully!';
        if (this.userType == 'mentor') {
          this.successMessage = 'Mentor Edited Successfully!';
        }

        this.doFormReset();

        this.$refs.first_name.focus();

        setTimeout(() => {
          this.successMessage = '';
          this.$emit('closeMentorModal');
          window.location.reload(); 
        }, 2000);
    })
    .catch(error => {
      this.disable_edit_btn = false;
        const fieldErrors =  [{}];
        var errMsgObj = error.response.data.message;
        Object.keys(errMsgObj).map(key => {
            var newFieldErr = {field:key, msg:errMsgObj[key]};
            fieldErrors.push(newFieldErr);
        });
        this.$validator.errors.add(fieldErrors);
    });
    }
  },
  navigate(path) {
    router.push(path);
  },
    getEditUser(type, id) {
      // if (this.$route.params.account_id) {
      //   this.accountId = this.$route.params.account_id;
      // } else {
      //   this.accountId = this.$store.state.user_accountid;
      // }

      this.accountId = this.$store.state.user_accountid;

      // this.userId = this.$route.params.user_id;

      this.userId = id;

      var roles = store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
      var role = 'ROLE_MENTOR';
      if(this.userType == 'manager') {
        role = 'ROLE_ADMIN';
      }
      axios('/accountgroupsactive',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
            current_mentor_id: this.userId,
          }
        },
      )
      .then(response => {
          this.groups = response.data;        
        })
      .catch(error => {

      });

      axios.get('/desktop/course-lists', {
        params: {
          user_roles: role,
          accountId: this.$store.state.user_accountid
          }
        })
        .then(response =>  {
          this.courses = response.data;
          for(var i=0; i < response.data.length; i++) {
            var list = {id: response.data[i].id + '-' + response.data[i].type, name: response.data[i].name};
            this.taskList.push(list);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
        this.getPathwayLists();
      axios.get('/desktop/assessment-builder-lists', {
      params: {
        user_roles: role,
        accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.assessments = response.data;
        for(var i=0; i < response.data.length; i++) {
          var list = {id: response.data[i].id + '-' + response.data[i].type, name: response.data[i].name};
          this.taskList.push(list);
        }
        axios('/user-profile/' + this.userId,
        {
            method: 'POST',
            data: {
              accountId: this.$store.state.user_accountid
            }
        })
        .then(resp => {
            this.assessmentSelected = [];
            this.taskListSelected = [];

            this.first_name = resp.data.user.first_name;
            this.last_name = resp.data.user.last_name;
            this.phone_number = resp.data.user.phone_number;
            this.email_addr = resp.data.user.email;
            this.assessmentSelected = resp.data.mentee_assessment;
            console.log(this.assessmentSelected);
            this.courseSelected = resp.data.user_courses;  
            for(var i=0; i<this.assessmentSelected.length; i++) {
              var idd = this.assessmentSelected[i] + '-' + 'Assessment';
              this.taskListSelected.push(idd)
            }
            for(var i=0; i<this.courseSelected.length; i++) {
              var idd = this.courseSelected[i] + '-' + 'Course';
              this.taskListSelected.push(idd)
            }
            console.log(this.taskListSelected);
            this.userStatus = resp.data.user.user_status;
            this.userId = resp.data.user.userId;
            this.padminflag = resp.data.padminflag;
            this.editpathwaySelected = resp.data.mentee_pathway;
            this.editShowFutureSteps = resp.data.show_future_steps;
            this.editStepSelected = resp.data.begin_step;
            this.existingPathway =  resp.data.mentee_pathway;
            this.mentor_assigned = resp.data.mentor_assigned;
            if(this.editpathwaySelected > 0) {
              for(var i=0; i<this.editPathwayList.length; i++) {
                  if(this.editpathwaySelected == this.editPathwayList[i].id) {
                      this.getPathwaySteps();
                  }
                  
              }
            }


        })
        .catch(() => {
            this.loading = false;
        })
      })
      .catch(function(error) {
        console.log(error);
      });

      axios('/desktop/manager/manage-license', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          menteeId: this.userId,
        }
      })
      .then(resp => {
        let accountItems = resp.data;
        this.menteeCount = accountItems.menteesApprentices.length;
        // this.menteesApprentices = accountItems.menteesApprentices;

        let menteesApprentices = accountItems.menteesApprentices.filter(item => item.status == 'Active');
        this.menteesApprentices = menteesApprentices;
        
      })
      .catch(() => {
      });

      axios('/desktop/v2/manager/mentees-list', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          user_id: this.userId,
        }
      })
      .then(resp => {
        let data = resp.data;
        this.assign_mentees = data;
        
      })
      .catch(() => {
      });
    },
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  created: function() {
    
  }
}
</script>
<style scoped>
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 75%;
  background-color: #FFF;
  padding: 30px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}
.content-main-wrapper {
  width: 90% !important;
  background-color: #FFF !important;
  padding: 25px;
}
input {
  line-height: 17px;
  border-radius: 10px;
  padding-left: 5px !important;
  border: 1px solid #707070;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;    
}
.add-form-wrapper {
  margin: 0px 10px 0px 30px; 
}
.add-mentee-form label.bold{
  font-weight: 600;
  padding-left: 0px;
}
.month-picker-input-container {
  width: 100% !important;
}
.month-picker-input {
  width: 100%;
}
.month-picker__container {
  z-index: 1;
  width: 100% !important;
}
.month-picker-elm-container {
  position: relative;
}
.month-picker-elm-container .fa-calendar {
  position: absolute;
  top: 35%;
  right: 5%;
  pointer-events: none;
}    
.save_add_link:focus {
  box-shadow: none;
}
.inactivate_link,
.inactivate_link:focus,
.inactivate_link:active,
.inactivate_link:hover {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/edit_mentor.vue